import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { UserFull } from '@wellesley/openapi'
import { rootReducer } from '@wellesley/store'

export type View = 'create' | 'default' | UserFull

export type manageUsersSliceState = {
  view: View
  transitView: View | null
  isProfileFormDirty: boolean
}

const initialState: manageUsersSliceState = {
  view: 'default',
  transitView: null,
  isProfileFormDirty: false,
}

export const manageUsersSlice = createSlice({
  name: 'manageUsers',
  initialState,
  reducers: {
    changeView: (state, { payload }: PayloadAction<View>) => {
      if (state.isProfileFormDirty) {
        state.transitView = payload
      } else {
        state.view = payload
        state.transitView = null
      }
    },
    resetTransitView: (state) => {
      state.transitView = null
    },
    changeProfileFormDirty: (state, { payload }: PayloadAction<boolean>) => {
      state.isProfileFormDirty = payload
    },
  },
  selectors: {
    selectView: (state) => state.view,
    selectTransitView: (state) => state.transitView,
    selectIsProfileFormDirty: (state) => state.isProfileFormDirty,
  },
}).injectInto(rootReducer)
